import React from 'react';
import Contact from '../components/Contact/Contact';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import { FaLocationDot } from "react-icons/fa6";
import Title from '../components/Title/Title';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <>
      <div style={{ marginTop: "60px", minHeight: "500px" }}>
        <Title subTitle="Contact Us " title="Get in Touch" />
        <Contact />

        <div className="contact-info-cards">
          <a
            href="mailto:vikastyagi77@yahoo.com"
            className="contact-info-card"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact-info-icon">
              <FaEnvelope />
            </div>
            <div className="contact-info-content">
              <span className="contact-info-title">Email Us</span>
              <span className="contact-info-text">vikastyagi77@yahoo.com</span>
            </div>
          </a>

          <a
            href="tel:+91-9718603456"
            className="contact-info-card"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact-info-icon">
              <FaPhone />
            </div>
            <div className="contact-info-content">
              <span className="contact-info-title">Call Us</span>
              <span className="contact-info-text">+91-9718603456</span>
            </div>
          </a>

          <a
            href="https://maps.app.goo.gl/NJRwnBsfpZB58k8TA"
            className="contact-info-card"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact-info-icon">
              <FaLocationDot />
            </div>
            <div className="contact-info-content">
              <span className="contact-info-title">Visit Us</span>
              <span className="contact-info-text">
                Village & Post Office: Dhanauri, Roorkee, Haridwar (U.K).
              </span>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
